import { useGetAuth } from "../../../hooks/useGetAuthHook";
import { User } from "../../../types/types";
import { Mail, Phone, Calendar, Building2 } from "lucide-react";

const Left = () => {
  const { data: user, isLoading } = useGetAuth<User>("user");

  const joinedDate = user?.created_at
    ? new Date(user.created_at).toLocaleDateString("en-US", {
        month: "long",
        year: "numeric",
      })
    : null;

  return (
    <div className="space-y-4 md:col-span-1">
      <div className="overflow-hidden rounded-xl bg-white shadow-sm">
        {/* Cover */}
        <div className="h-20 bg-gradient-to-r from-orange-400 to-orange-500" />

        <div className="relative px-4 pb-5 pt-2">
          {isLoading ? (
            <>
              <div className="-mt-8 mb-3 h-16 w-16 rounded-full border-4 border-white bg-gray-300 animate-pulse shadow-md" />
              <div className="h-5 w-32 bg-gray-200 rounded animate-pulse" />
              <div className="mt-4 space-y-2">
                <div className="h-3 w-40 bg-gray-100 rounded animate-pulse" />
                <div className="h-3 w-36 bg-gray-100 rounded animate-pulse" />
              </div>
            </>
          ) : (
            <>
              {/* Avatar */}
              <img
                src={user?.photo_url || "/placeholder.svg"}
                alt={user?.name}
                className="-mt-8 mb-3 h-16 w-16 rounded-full border-4 border-white object-cover shadow-md"
              />

              {/* Name */}
              <h3 className="text-base font-semibold text-gray-900 capitalize leading-tight">
                {user?.name || "John Doe"}
              </h3>

              {/* Info rows */}
              <div className="mt-4 space-y-2.5 text-xs text-gray-600">
                {user?.email && (
                  <div className="flex items-center gap-2">
                    <Mail className="h-3.5 w-3.5 text-orange-500" />
                    <span className="truncate max-w-48">{user.email}</span>
                  </div>
                )}

                {user?.phone && (
                  <div className="flex items-center gap-2">
                    <Phone className="h-3.5 w-3.5 text-orange-500" />
                    <span>{user.phone}</span>
                  </div>
                )}

                {user?.company && (
                  <div className="flex items-center gap-2">
                    <Building2 className="h-3.5 w-3.5 text-orange-500" />
                    <span className="truncate max-w-48">{user.company}</span>
                  </div>
                )}

                {joinedDate && (
                  <div className="flex items-center gap-2">
                    <Calendar className="h-3.5 w-3.5 text-orange-500" />
                    <span>Joined {joinedDate}</span>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Left;
